import InfluencerCard from "Components/influencer/InfluencerCard"
import React, { useEffect, useState } from "react"
import { Collaboration, CollaborationPost } from "types/campaign/collaborations"
import { Post } from "types/influencer"
import { AppDispatch, RootState } from "store"
import { useDispatch, useSelector } from "react-redux"
import { showInfluencerPostModal, toggleApplicationOffcanvas, togglePostPerformanceOffcanvas } from "slices/ui/reducer"
import { Swiper, SwiperSlide } from "swiper/react"
import { Navigation } from "swiper/modules"
import 'swiper/css';
import 'swiper/css/navigation';
import { useParams } from "react-router-dom"
import ReelsIcon from "assets/icons/ReelsIcon"
import IGStoryIcon from "assets/icons/mono/IGStoryIcon"
import IGPostIcon from "assets/icons/mono/IGPostIcon"

interface CollaborationCardProps {
    collaboration: Collaboration
}

const CollaborationCard: React.FC<CollaborationCardProps> = ({ collaboration }) => {

    const { campaignId } = useParams();
    const campaign = useSelector((state: RootState) => state.campaigns.items[campaignId!]?.data?.campaign);

    const [selectedPost, setSelectedPost] = useState<null | CollaborationPost>(null);

    const influencerPostModalVisibile = useSelector((state: RootState) => state.ui.influencerPostModal);

    const dispatch: AppDispatch = useDispatch();

    useEffect(() => {
        if (selectedPost) {
            dispatch(showInfluencerPostModal({ postId: selectedPost.social_post.uuid, collaborationId: collaboration.uuid, influencer: collaboration.influencer, socialAccount: collaboration.social_account, status: selectedPost.status as "pending" | "approved" | "rejected" | "processing", preventAction: true }))
        }
    }, [selectedPost])


    useEffect(() => {
        setSelectedPost(null)
    }, [influencerPostModalVisibile])

    return (
        <React.Fragment>
            <div className="collaboration-card mb-4">
                <div className="row h-100 m-0 flex-nowrap">
                    <div className="col-sm-12 col-md-6 col-lg-3 col-xl-3 border-right-1 h-100 p-0">
                        <div  onClick={() => {
                                dispatch(toggleApplicationOffcanvas({ campaignId: campaignId!, influencerId: collaboration.influencer?.uuid, socialAccountId: collaboration.social_account?.uuid, status: 'accepted' }))
                            }}>
                        <InfluencerCard
                         name={collaboration.influencer?.name ?? (collaboration?.social_account?.name ?? `@${collaboration.social_account?.handle}`)} socialAccount={collaboration.social_account} application={collaboration.application} language={collaboration.language?.name} />
                        </div>
                        {
                            collaboration.influencer && campaign?.mode !== 'offline' &&
                            <a
                                href={`/collaboration/campaign/${campaignId}/collaboration/${collaboration.influencer.uuid}${collaboration?.active_milestone?.id ? '/milestone/'+collaboration.active_milestone.id : ''}`}
                                target="_blank"
                                rel="noreferrer"
                                className="btn btn-primary-light w-100 campaign-edit-btn d-flex justify-content-between bottom-left-radius-only border-0 fs-12px">View Collab Details <i className=" bx bx-right-arrow-alt"></i></a>
                        }
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-9 col-xl-9 h-100 p-2">
                        <div className="collaboration-media-card">
                            {
                                collaboration.posts.length > 0 &&
                                <Swiper
                                    slidesPerView={'auto'}
                                    spaceBetween={30}
                                    navigation={true}
                                    modules={[Navigation]}
                                    freeMode={true}
                                    className="mySwiper">
                                    {
                                        collaboration.posts.map((post, i) => {
                                            return (
                                                <SwiperSlide className="w-auto" key={i}>
                                                    <div onClick={() => setSelectedPost(post)} className="position-relative h-100 post-thumbnail" style={{ backgroundImage: `url(${post.social_post.thumbnail_url})` }}>
                                                        {
                                                            post.status === 'approved' && <span className="post-status-badge approved"> <i className="bx bx-check"></i>Approved</span>
                                                        }
                                                        {
                                                            post.status === 'pending' && <span className="post-status-badge new">New</span>
                                                        }
                                                        {
                                                            post.status === 'rejected' && <span className="post-status-badge declined"> <i className="bx bx-x"></i>Declined</span>
                                                        }
                                                        {
                                                            post.social_post.type === 'REELS' &&
                                                            <span className="media-type-icon">
                                                                <ReelsIcon color="#FFFFFF" />
                                                            </span>
                                                        }
                                                        {
                                                            post.social_post.type === 'STORY' &&
                                                            <span className="media-type-icon">
                                                                <IGStoryIcon />
                                                            </span>
                                                        }
                                                        {
                                                            post.social_post.type === 'VIDEO' &&
                                                            <span className="media-type-icon">
                                                                <i className="ri-youtube-fill" style={{ fontSize: '24px', color: '#FFFFFF' }}></i>
                                                            </span>
                                                        }
                                                        {
                                                           !["REELS", "STORY", "VIDEO"].includes(post.social_post.type) &&
                                                            <span className="media-type-icon">
                                                                <IGPostIcon />
                                                            </span>
                                                        }
                                                    </div>
                                                </SwiperSlide>

                                            )
                                        })
                                    }
                                </Swiper>
                            }
                            {
                                (!Array.isArray(collaboration.posts) || collaboration.posts.length === 0) &&
                                <div className="col-12 h-100 w-100 d-flex justify-content-center align-items-center">
                                    <span className="no-collaboration-posts-msg">Waiting for collaboration post</span>
                                </div>
                            }
                            <span className="total-posts-count">Total Posts : <span className="fw-500">{collaboration.posts.length}</span></span>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>

    )
}

export default CollaborationCard